import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from 'components/button/button'
import MainHeaderNav from 'sections/main-header-nav'

import ProfilePicture from 'components/profile/profile-picture'

import ActivityList from 'components/activity-list/activity-list'
import SinglePersonDetails from './single-person-details'
import SinglePersonTracking from './single-person-tracking'

import {
    getTeamMemberData,
    changeTitle,
    openModal,
    createOrReturnChat
} from 'state/actions'

import {
    getCurrentUser,
    getCurrentAccount,
    getUserRoles
} from 'state/selectors'

import {
    getMeta
} from 'utils'

import { Route, Redirect, withRouter } from 'react-router'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'

class SinglePerson extends Component {
    state = {
        loading: true
    }

    parentUrl = this.props.match.path.replace(':user_id', '')

    UNSAFE_componentWillMount = _ => {
        this.getData(this.props)
    }
    
    UNSAFE_componentWillUpdate = nextProps => {
        if(!this.props.user){
            this.getData(nextProps)
        }
    }

    getData = props => {
        const {
            getTeamMemberData,
            user,
            changeTitle
        } = props

        if(!user){
            return
        }

        this.setState({
            loading: true
        })

        getTeamMemberData(user.id, false, _ => {
            this.setState({
                loading: false
            })
        })

        changeTitle(user.first_name+' '+user.last_name)
    }
    
    backToTeams = _ => {
        this.props.history.push(this.parentUrl)
    }

    openChat = _ => {
        this.props.createOrReturnChat(null, this.props.user, _ => {})
    }
    
    delete = _ => {
		this.props.openModal('delete', 'user', {
			account: this.props.currentAccount,
			type: 'user',
			user: this.props.user,
		})
    }

    edit = _ => {
		this.props.openModal('edit', 'settings', {
			type: 'user',
			user: this.props.user
		})
    }

    render() {
        const {
            match,
            location,
            user,
            currentAccount,
        } = this.props

        const {
            loading
        } = this.state

        this.navtabs = [
            {
                name: 'Activity',
                path: 'activity',
                component: ActivityList
            },{
                name: 'Time Tracking',
                path: 'tracking',
                component: SinglePersonTracking
            },{
                name: 'Details',
                path: 'details',
                component: SinglePersonDetails
            }
        ]

        if(!user){
            return (
                <Redirect
                    to={this.parentUrl}
                />
            )
        }

        return (
            <div className="single-index">
                <header className="main-header">
                    <div className="title-with-image">
                        <ProfilePicture 
                            user={user} 
                            isTiny={false} 
                            size="original"
                        />
                        <h1>
                            { user.first_name+' '+user.last_name }
                        </h1>
                        <div className="sub-title-area">
                            <span>
                                { user.role ? user.role : 'Guest' } • { user.email }<br />
                                Works { getMeta(user, 'hoursWorked', currentAccount) } hours per week.
                            </span>
                        </div>
                    </div>
                    <div className="button-area">
                        <Button 
                            size="small" 
                            label="Back to teams" 
                            icon="angle-left" 
                            callback={this.backToTeams} 
                        />
                        <Button 
                            size="small" 
                            label="Open chat" 
                            icon="fe-mail" 
                            callback={this.openChat} 
                        />
                        <Button 
                            size="small" 
                            label="Edit user" 
                            icon="fe-edit-2" 
                            callback={this.edit} 
                        />
                        <Button 
                            size="small" 
                            label="Delete user" 
                            icon="fe-trash-2" 
                            callback={this.delete} 
                        />
                    </div>
                    <MainHeaderNav
                        right={true}
                        relUrl={match.url}
                        callback={this.changeTeamTab}
                        navtabs={this.navtabs}
                        type='routes'
                    />
                </header>
                <main>
                    <SwitchCSSTransitionGroup 
                        location={location} 
                        transitionName="slide" 
                        transitionEnterTimeout={300} 
                        transitionLeaveTimeout={300}
                    >
                        {this.navtabs.map((object, i) => {
                            return (
                                <Route path={match.url + '/' + object.path} key={i} render={props => {
                                    let ThisComponent = object.component

                                    return (
                                        <ThisComponent
                                            {...props}
                                            context={'user'}
                                            user={user}
                                            loading={loading}
                                        />
                                    )
                                }} />
                            )
                        })}
                        <Redirect from={match.url} exact to={match.url + '/details'} />
                    </SwitchCSSTransitionGroup>
                </main>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        userData: getCurrentUser(state),
        currentAccount: getCurrentAccount(state),
        allUsers: state.account.entities.users,
        user: state.account.entities.users ? state.account.entities.users[ownProps.match.params.user_id] : null,
        userRoles: getUserRoles(state),
    }
}

export default withRouter(connect(mapStateToProps, {
    getTeamMemberData,
    changeTitle,
    openModal,
    createOrReturnChat
})(SinglePerson))